<template>
  <div id="app">
    <v-app id="inspire">
      <!-- nav -->
      <v-navigation-drawer
        v-model="drawer"
        app
        v-if="!isLoginPage"
        color="#fff"
      >
        <v-list nav dense>
          <template v-for="(item, i) in items">
            <v-list-group
              v-if="item.children"
              :key="i"
              :value="navActive(item)"
              class="custom-nav-list"
              no-action
            >
              <template v-slot:activator>
                <v-list-item-action>
                  <v-icon>{{ item.icon }}</v-icon>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ item.title }}</v-list-item-title>
                </v-list-item-content>
              </template>
              <v-list-item
                v-for="(child, i) in item.children"
                :key="i"
                :to="child.link"
                class="custom-nav-list"
              >
                <v-list-item-content>
                  <v-list-item-title>{{ child.title }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>

            <v-list-item
              v-else
              :key="i"
              :to="item.link"
              class="custom-nav-list"
            >
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
      </v-navigation-drawer>
      <!-- // nav -->
      <!-- bar -->
      <v-app-bar app flat class="custom-theme-bg">
        <v-app-bar-nav-icon
          v-if="!isLoginPage"
          @click.stop="drawer = !drawer"
        ></v-app-bar-nav-icon>
        <!-- <p class="mb-0 text-h6">{{ pageTitle }}</p> -->
        <v-spacer></v-spacer>
        <v-avatar class="white">
          <img src="@/assets/images/logo2.png" />
        </v-avatar>
      </v-app-bar>
      <!-- // bar -->
      <!-- main -->
      <!-- <v-main :class="!removeBg ? 'blue-grey lighten-5' : null"> -->
      <v-main class="custom-theme-bg">
        <!-- <v-main> -->
        <v-container fluid>
          <router-view></router-view>
        </v-container>
      </v-main>
      <!-- // main -->
    </v-app>
  </div>
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      drawer: null,
      showWriteBtn: false,
      items: [
        { icon: "mdi-view-dashboard", title: "대시보드", link: "/" },
        { icon: "mdi-calendar", title: "일정", link: "/calendar" },
        {
          icon: "mdi-stamper",
          title: "지출결의",
          link: "/approval",
          children: [
            { title: "지출결의", link: "/approval/list" },
            { title: "지출결의 등록", link: "/approval/write" },
          ],
        },
        {
          icon: "mdi-account-group",
          title: "직원",
          link: "/employee",
          children: [
            { title: "직원 조회", link: "/employee" },
            { title: "직원 등록", link: "/employeeWrite" },
            { title: "직원 휴가관리", link: "/employeeVacation" },
          ],
        },
        {
          icon: "mdi-clipboard-text-multiple-outline",
          title: "프로젝트",
          link: "/project",
          children: [
            { title: "프로젝트 조회", link: "/project/list" },
            { title: "프로젝트 등록", link: "/project/write" },
          ],
        },
        {
          icon: "mdi-folder-open",
          title: "자료실",
          link: "/data",
          children: [
            { title: "자료실 조회", link: "/data/list" },
            { title: "자료실 등록", link: "/data/write" },
          ],
        },
        {
          icon: "mdi-account-voice",
          title: "공지사항",
          link: "/notice/list",
          children: [
            { title: "공지사항 조회", link: "/notice/list" },
            { title: "공지사항 등록", link: "/notice/write" },
          ],
        },
        {
          icon: "mdi-cog",
          title: "설정",
          link: "/setting",
          children: [{ title: "일정구분 관리", link: "/setting/plan" }],
        },
      ],
    };
  },
  computed: {
    // pageTitle() {
    //   const path = this.$route.path;
    //   let title = "";
    //   // let link = "";

    //   this.items.forEach(v => {
    //     if (path.indexOf(v.link) >= 0) {
    //       if (v.children) {
    //         v.children.forEach(c => {
    //           if (path === c.link) {
    //             title = c.title;
    //             // link = c.link;
    //           }
    //         });
    //       } else {
    //         title = v.title;
    //         // link = v.link;
    //       }
    //     }
    //   });

    //   return title;
    // },
    isLoginPage() {
      if (this.$route.path === "/login") {
        return true;
      }
      return false;
    },
    removeBg() {
      if (this.$route.path === "/calendar") {
        return true;
      }
      return false;
    },
  },
  methods: {
    navActive(item) {
      const path = this.$route.path;
      const link = item.link;

      if (path.indexOf(link) >= 0) {
        return true;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.custom-theme-bg {
  background-color: #efeff1 !important;
}
/* .custom-theme-bg {
  background-color: #f6f6f7 !important;
} */
.user-btn:hover:before,
.user-btn:focus:before {
  background-color: transparent !important;
  transition: none !important;
}
.custom-nav-list.v-list-item--active {
  background-color: #3f82a4;
  color: #fff;
}
</style>
